import { InterpolatedTranslatePipe } from '../../../../pipe/interpolated-translate.pipe';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { EnvironmentService, NotificationStore } from '@web/service';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { cassiopeiaIcons } from '@nestech/utils';
import { Router } from '@angular/router';
import { Button } from '../../../../button/button';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'cas-top-navigation-quick-action',
  template: `
    @let n = notification();
    <cas-button
      [disableTooltip]="!n"
      [ngbTooltip]="n?.label | translate"
      (click)="goToSecureMail()"
      class="d-none d-md-block"
      theme="primary-light"
      size="sm">
      <fa-icon
        class="primary-dark"
        [icon]="icons.message"
        [fixedWidth]="true" />
      <span class="primary-dark fw-medium">{{ 'cas.writeMessageSubtitle' | translate }}</span>
      @if (n) {
        <div class="position-absolute top-0 start-100 translate-middle bullet bg-danger"></div>
      }
    </cas-button>
    <button
      class="btn p-0 d-md-none position-relative"
      (click)="goToSecureMail()">
      <fa-icon
        class="text-primary pointer"
        size="lg"
        [icon]="icons.message"
        [fixedWidth]="true" />
      @if (n) {
        <div class="position-absolute top-0 start-100 translate-middle bullet bg-danger"></div>
      }
    </button>
  `,
  imports: [Button, FaIconComponent, InterpolatedTranslatePipe, NgbTooltip],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    div.bullet {
      height: 12px;
      width: 12px;
      border-radius: 50%;
      border: 2px solid #fff;
    }
  `,
})
export class TopNavigationQuickActionComponent {
  #router = inject(Router);
  #environment = inject(EnvironmentService).environment;
  #notificationStore = inject(NotificationStore);
  notification = computed(() => {
    const notifications = this.#notificationStore.notifications();
    return notifications.find(({ id }) => id === 'NEW_CHAT_MESSAGE');
  });

  icons = cassiopeiaIcons;

  secureMail = this.#environment.contactInfo.secureMail;

  goToSecureMail(): void {
    this.secureMail
      ? window.open(this.secureMail, '_blank')
      : this.#router.navigate(['contact', this.#environment.contactInfo.contactForm?.type?.toLocaleLowerCase()]);
  }
}
